import { render } from "./SectionTravelSchedule.vue?vue&type=template&id=99312078&scoped=true"
import script from "./SectionTravelSchedule.vue?vue&type=script&lang=js"
export * from "./SectionTravelSchedule.vue?vue&type=script&lang=js"

import "./SectionTravelSchedule.vue?vue&type=style&index=0&id=99312078&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99312078"]])

export default __exports__